import { OccType, PriceChannel, PriceType, SourceChannelType } from '@/config';
import { IdataSource } from '@/utils';
import { DateType } from '@/utils/date';
import actionType from '../actions/channel/actionType';

export interface Strategy {
  strategyId: number;
  strategyName: string;
}

export interface Channel {
  channelId: number;
  channelName: string;
  channelType: SourceChannelType;
  duration: number;
  occType: string;
  active: number; // 启用标识【0停用1启用】
  activeName: string;
  canDelete: boolean;
  category: string; // 计价专用渠道分类【CRS|WALK_IN】
  commonCode: string;
  createBy: string;
  createTime: number;
  deleteFlag: boolean;
  directFlag: boolean; // 是否直连渠道
  id: number | string;
  // memberFlag: boolean; // 会员体系标识
  name: string; // 渠道名称
  otaBillType: string; // OTA抛帐对应的账单细分类型（后台手动配置）
  preSettingFlag: boolean; // 是否系统预设
  priceStrategies: Array<{
    canDelete: boolean;
    channelId: number;
    createBy: string;
    createTime: number;
    deleteFlag: boolean;
    departureDate: string;
    id: number;
    name: string; // 计价名称
    occType: OccType;
    priceType: PriceType;
    updateBy: string;
    updateTime: number;
  }>;
  relateId: number; // 门店渠道关联id
  type: SourceChannelType; // 渠道类型【CRS|OTA|OTHER|WALK_IN】
  updateBy: string;
  updateTime: number;
  viewTag: string;
  priceChannel: PriceChannel;
}

export interface ChannelInfo {
  channelId: number;
  commonCode: string;
  createBy: string;
  createTime: number;
  deleteFlag: boolean;
  id: number;
  occDuration: number;
  occType: OccType;
  reserveQuantity: number; // 房量预留数量
  roomQuantity: number; // 房间数
  roomTypeId: number;
  roomTypeName: string;
  roomTypeViewName: string; // 房型展示名称
  shelfStatus: number; // 上下架状态【0上架1下架】
  updateBy: string;
  updateTime: number;
  timeInterval: Array<string>; // 每日可订时段
  bookStartTime: string; // 可预订结束时段
  bookEndTime: string; // 可预订开始时段
  shelfQuantity?: number; // 上架房量
  occupiedQuantity?: number; // 已被占用
}

// 共享房型
export type ShareRoomTypeItem = {
  endDate?: string; // 过期日期
  roomTypeId: number; // 房型ID
  roomTypeName: string; // 房型名称
  sort: number; // 排序
};

export interface DirectRoomType {
  enabledCount: number; // 可用房间总数
  logicRoomTypeQuantity: number; // 逻辑房型直连库存
  maxBookCount: number; // 直连渠道最大可定数
  reserveQuantity: number; // 直连渠道不可定数
  roomTypeId: number; // 房型ID
  roomTypeName: string; // 房型名称
  shareFlag: boolean; // 是否共享房型
  totalCount: number; // 房间总数
  slaveRoomTypes: Array<ShareRoomTypeItem>; // 共享房型列表
}

export interface RangeOption {
  startDate: DateType; // 开始时间
  endDate: DateType; // 截至日期
}

export interface FilterParams {
  promotionEndTime: string;
  promotionStartTime: string;
  promotionType: string;
  recordState: string;
  productId: null | number;
}

interface InitialState {
  calcLoading: boolean;
  hotelDirectRoomTypeList: Array<DirectRoomType>;
  hotelChannelList: Array<Channel>;
  hotelChannelDataSource: Array<IdataSource>;
  dayUseList: Array<ChannelInfo>;
  timeRentList: Array<ChannelInfo>;

  dateRangeOption: RangeOption[]; // 筛选时间范围选项
  dateRangeIndex: number; // 当前筛选时间下标
  crsDayRoomList: Array<any>;
  crsHourRoomList: Array<any>;

  enrolledList: Array<any>;
  filterParams: FilterParams;
}

const initialState: InitialState = {
  calcLoading: false,
  hotelDirectRoomTypeList: [],
  hotelChannelList: [],
  hotelChannelDataSource: [],
  dayUseList: [],
  timeRentList: [],

  dateRangeOption: [],
  dateRangeIndex: 0,
  crsDayRoomList: [],
  crsHourRoomList: [],

  // crs 已报名促销 storage.get('commonCode')
  enrolledList: [],
  filterParams: {
    promotionEndTime: '',
    promotionStartTime: '',
    promotionType: '',
    recordState: 'EFFECTED',
    productId: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.TOGGLE_LOADING: {
      const loading = state[action.payload];
      return {
        ...state,
        [action.payload]: !loading,
      };
    }
    case actionType.UPDATE_STATE:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.HOTEL_CHANNEL_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.CHANNEL_INFO_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.HOTEL_ROOM_TYPE_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SET_DATE_RANGE_OPTION:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SET_DATE_RANGE_INDEX:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.CRS_ROOM_QUANTITY_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.UPDATE_FILTER_PARAMS:
      return {
        ...state,
        filterParams: {
          ...state.filterParams,
          ...action.payload,
        },
      };
    case actionType.CALC_LOADING:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SET_ENROLLED_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.RESET_ENROLLED_DATA:
      return {
        ...state,
        enrolledList: [],
        filterParams: {
          promotionEndTime: '',
          promotionStartTime: '',
          promotionType: '',
          recordState: 'EFFECTED',
          roomTypeName: '',
        },
      };
    default:
      return state;
  }
};
